export default __webpack_public_path__ + "media/images/portfolio/portfolio-5-4782ba2ea29099ff4c887a9fc5adb514.jpg";